'use client';

import dynamic from 'next/dynamic';

import TvChartWebview from './tv-chart-webview';
import TvChartWebviewFullchart from './tv-chart-webview-fullchart';
import { TvLoading } from './tv-loading';
import { TvScript } from './tv-script';

const TvChartWeb = dynamic(() => import('./tv-chart-web'), { ssr: false, loading: TvLoading });

export { TvScript, TvChartWeb, TvChartWebview, TvChartWebviewFullchart };
export type { ChartTradeCallbacks, DesktopTradeCallbacks, WebviewBridgeTradeCallbacks } from './chart-trade-callbacks';
export { createChartLoadSession } from './observability/chart-load-recorder';
export type { ChartLoadSession, ChartLoadTrigger, ChartSurface } from './observability/chart-load-recorder';
export type { TpSlDragIntent } from './custom-header/plugins/order-trackers/line-helpers/draggable-tpsl-line-helper/tp-sl-drag-intent';
export {
  sendClosePosition,
  sendTpSlDelete,
  sendTpSlDragCreateIfWebview,
  sendTpSlModify,
  type TpSlDragContext,
} from './custom-header/plugins/order-trackers/line-helpers/draggable-tpsl-line-helper/tp-sl-drag-bridge';
export {
  ENABLED_FEATURE,
  isDraggableTpslEnabled,
  parseEnabledFeatures,
} from './custom-header/plugins/order-trackers/line-helpers/draggable-tpsl-line-helper/enabled-features';
